const AdmissionsPage = () => {
  return <div className="container admissions-page">Admissions Page</div>;
};

export default AdmissionsPage;
